var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("h6", [_vm._v("Сабстатусы")]),
              _vm._v(" "),
              _vm._l(
                [...(_vm.$invoiceSubStatuses || []), ..._vm.newRecords],
                function (s) {
                  return _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: s.id,
                          expression: "s.id",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "number", disabled: "" },
                      domProps: { value: s.id },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(s, "id", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: s.title,
                          expression: "s.title",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: s.title },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(s, "title", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: s.store_id,
                            expression: "s.store_id",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { disabled: !_vm.newRecordsIds[s.id] },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              s,
                              "store_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.$AllStores, function (store) {
                        return _c("option", { domProps: { value: store.id } }, [
                          _vm._v(_vm._s(store.title)),
                        ])
                      }),
                      0
                    ),
                  ])
                }
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-1 flex justify-content-between" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      on: { click: _vm.addNewRecord },
                    },
                    [_vm._v("Добавить сабстатус")]
                  ),
                  _vm._v(" "),
                  _c("LoadingButton", {
                    attrs: {
                      title: "Сохранить",
                      loading: _vm.btnLoading,
                      color: _vm.$constants.SUCCESS_COLOR,
                      onClick: () => _vm.updateRecords(),
                      className: "btn btn-outline-success",
                    },
                  }),
                ],
                1
              ),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Настройки накладных")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }